import React, { useState, useEffect } from 'react'
import { Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import d_a_client from '../lib/auth0'

const LoginIcon = () => {
  const [user, setUser] = useState(null)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        await d_a_client.init()
        const userInfo = await d_a_client.get_user()
        if (userInfo) {
          setUser(userInfo)
          setIsLoggedIn(true)
        }
      } catch (error) {
        console.error('Error checking auth status:', error)
      }
    }

    checkAuthStatus()
  }, [])

  const handleLogin = async () => {
    try {
      await d_a_client.init()
      await d_a_client.do_login()
      // After login, redirect to afterlogin page
      // navigate('/afterlogin')
    } catch (error) {
      console.error('Error during login:', error)
    }
  }

  const handleUserClick = () => {
    if (isLoggedIn) {
      navigate('/afterlogin')
    }
  }

  return (
    <div className="d-flex align-items-center me-3">
      {isLoggedIn && user ? (
        <Button
          variant="link"
          className="p-0 border-0"
          onClick={handleUserClick}
          style={{ textDecoration: 'none' }}
        >
          {user.picture ? (
            <img
              src={user.picture}
              alt="User avatar"
              className="rounded-circle"
              style={{ width: '32px', height: '32px' }}
            />
          ) : (
            <div
              className="rounded-circle bg-secondary d-flex align-items-center justify-content-center"
              style={{ width: '32px', height: '32px', fontSize: '16px', color: 'white' }}
            >
              👤
            </div>
          )}
        </Button>
      ) : (
        <Button
          variant="link"
          className="p-0 border-0"
          onClick={handleLogin}
          style={{ textDecoration: 'none' }}
        >
          <div
            className="rounded-circle bg-light d-flex align-items-center justify-content-center"
            style={{
              width: '32px',
              height: '32px',
              fontSize: '16px',
              color: '#6c757d',
              border: '2px solid #dee2e6'
            }}
          >
            👤
          </div>
        </Button>
      )}
    </div>
  )
}

export default LoginIcon